import React, { useState } from "react";

interface Tab {
  label: string;
  content: React.ReactNode;
}

interface TabsProps {
  tabs: Tab[];
}

export const Tabs: React.FC<TabsProps> = ({ tabs }) => {
  const [i, setI] = useState(0);

  return (
    <div className="tabs">
      <div className="tabs__bar" role="tablist">
        {tabs.map((t, idx) => (
          <button
            key={idx}
            className={"tabs__btn" + (i === idx ? " is-active" : "")}
            onClick={() => setI(idx)}
            role="tab"
          >
            {t.label}
          </button>
        ))}
      </div>
      <div className="tabs__panel">{tabs[i].content}</div>
    </div>
  );
};
